import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../services/adminAuth';

const AdminProtectedRoute = ({ children }) => {
  const isAuth = isAuthenticated();
  
  if (!isAuth) {
    // Redirect to login if not authenticated
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

export default AdminProtectedRoute; 